import { makePropCacheMixin } from '../utils/cache';
export default makePropCacheMixin('$attrs', 'bvAttrs');


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/mixins/attrs.js
// module id = 33
// module chunks = 43